import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { TimelineItem, UpdateTimelinePayload } from 'views/Tasks/Timeline/types';

type UpdateTimelineVariables = {
    orgId: string;
    dealId: number;
    timelineId: string;
    patchData: UpdateTimelinePayload;
};

export const updateTimeline = async ({
    orgId, dealId, timelineId, patchData,
}: UpdateTimelineVariables): Promise<TimelineItem> => {
    const response = await axiosInstance.patch(API_ENDPOINTS.TIMELINE_BY_ID(orgId, dealId, timelineId), patchData);
    return response.data;
};

export const useUpdateTimeline = (onSuccess: (data: TimelineItem, variables: UpdateTimelineVariables) => void) => useMutation({
    mutationFn: updateTimeline,
    onSuccess,
});
